/* tslint:disable */
import {
  Upload
} from '../index';

declare var Object: any;
export interface BankTransactionInterface {
  "orderIndex": number;
  "uploadId": number;
  "handler"?: string;
  "payer"?: string;
  "orderReference"?: string;
  "depositDate"?: string;
  "amount"?: string;
  "bank"?: string;
  "branch"?: string;
  "remarks"?: string;
  "status"?: number;
  "completedDate"?: Date;
  "error"?: string;
  "id"?: number;
  upload?: Upload;
}

export class BankTransaction implements BankTransactionInterface {
  "orderIndex": number;
  "uploadId": number;
  "handler": string;
  "payer": string;
  "orderReference": string;
  "depositDate": string;
  "amount": string;
  "bank": string;
  "branch": string;
  "remarks": string;
  "status": number;
  "completedDate": Date;
  "error": string;
  "id": number;
  upload: Upload;
  constructor(data?: BankTransactionInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `BankTransaction`.
   */
  public static getModelName() {
    return "BankTransaction";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of BankTransaction for dynamic purposes.
  **/
  public static factory(data: BankTransactionInterface): BankTransaction{
    return new BankTransaction(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'BankTransaction',
      plural: 'BankTransactions',
      path: 'BankTransactions',
      idName: 'id',
      properties: {
        "orderIndex": {
          name: 'orderIndex',
          type: 'number'
        },
        "uploadId": {
          name: 'uploadId',
          type: 'number'
        },
        "handler": {
          name: 'handler',
          type: 'string'
        },
        "payer": {
          name: 'payer',
          type: 'string'
        },
        "orderReference": {
          name: 'orderReference',
          type: 'string'
        },
        "depositDate": {
          name: 'depositDate',
          type: 'string'
        },
        "amount": {
          name: 'amount',
          type: 'string'
        },
        "bank": {
          name: 'bank',
          type: 'string'
        },
        "branch": {
          name: 'branch',
          type: 'string'
        },
        "remarks": {
          name: 'remarks',
          type: 'string'
        },
        "status": {
          name: 'status',
          type: 'number',
          default: 0
        },
        "completedDate": {
          name: 'completedDate',
          type: 'Date'
        },
        "error": {
          name: 'error',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        upload: {
          name: 'upload',
          type: 'Upload',
          model: 'Upload',
          relationType: 'belongsTo',
                  keyFrom: 'uploadId',
          keyTo: 'id'
        },
      }
    }
  }
}
